import { render, staticRenderFns } from "./WorkerContactInfo.vue?vue&type=template&id=05b67680&scoped=true&"
import script from "./WorkerContactInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorkerContactInfo.vue?vue&type=style&index=0&id=05b67680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b67680",
  null
  
)

export default component.exports